import api from "../services/api";

export default class APIGet {
  /**
   *
   * @param {string} url rota
   * @param {object} params get params
   * @returns {{ error: boolean, errors: string[] }}
   */
  static async get(url, params) {
    try {
      const response = await api.get(url, { params });
      let { data } = response;
      if (!data.error) data.errors = [];
      return data;
    } catch (error) {
      return {
        error: true,
        errors: ["NÃO FOI POSSÍVEL ENVIAR A SOLICITAÇÃO"],
      };
    }
  }

  /**
   * @returns {{ error: boolean, errors: string[], stock_groups: [] }}
   */
  static async getStockGroups(params = null) {
    return await APIGet.get("/rest-home/stock/groups", params);
  }

  /**
   * @returns {{ error: boolean, errors: string[], associations: [] }}
   */
  static async getStockGroupsAssociatedCategories() {
    return await APIGet.get("/rest-home/stock/groups/associated-categories");
  }

  /**
   * @returns {{ error: boolean, errors: string[], stock_item_units_of_measurement: [] }}
   */
  static async getStockItemUnitsOfMeasurement() {
    return await APIGet.get("/rest-home/stock/items/units-of-measurement");
  }

  /**
   * @returns {{ error: boolean, errors: string[], stock_item_types: [] }}
   */
  static async getStockItemTypes(params = null) {
    return await APIGet.get("/rest-home/stock/items/types", params);
  }

  /**
   * @returns {{ error: boolean, errors: string[], stock_item_categories: [] }}
   */
  static async getStockItemCategories() {
    return await APIGet.get("/rest-home/stock/items/categories");
  }

  /**
   * @param {{ stock_item_type_id: number, stock_item_category_id: number }} params
   * @returns {{ error: boolean, errors: string[], stock_items: [] }}
   */
  static async getStockItems(params) {
    return await APIGet.get("/rest-home/stock/items", params);
  }

  /**
   * @param {{ provider_id: number }} params
   * @returns {{ error: boolean, errors: string[], stock_items: [] }}
   */
  static async getStockItemsByProviderID(params) {
    return await APIGet.get("/rest-home/stock/items-by-provider-id", params);
  }

  /**
   * @param {{ resident_id: number, stock_group_id: number, stock_item_type_id: number, stock_item_category_id: number }} params
   * @returns {{ error: boolean, errors: string[], stocked_items: [] }}
   */
  static async getStockedItems(params) {
    return await APIGet.get("/rest-home/stock", params);
  }

  /**
   * @returns {{ error: boolean, errors: string[], residents: [] }}
   */
  static async getResidents(params) {
    return await APIGet.get("/rest-home/residents", params);
  }

  /**
   * @returns {{ error: boolean, errors: string[], providers: [] }}
   */
  static async getProviders() {
    return await APIGet.get("/rest-home/providers");
  }

  /**
   * @returns {{ error: boolean, errors: string[], data: [] }}
   */
  static async getFinanceActiveClients() {
    return await APIGet.get("/rest-home/financial/client-actives");
  }
}
